import React from 'react';
import styled from 'styled-components';
import InputForm from 'src/components/atoms/form/InputForm';
import { InputFormProps } from 'src/constants/Interface';
import InputLabelHolder from 'src/components/molecules/form/InputLabelHolder';

type Props = InputFormProps & {
  isRequired?: boolean;
  labelName: string;
};

export const SingleInputFormBlock = (props: Props) => {
  const {
    labelName,
    isRequired,
    inputType,
    inputValue,
    placeholder,
    onChange,
    onBlur,
    isError,
    isDisabeld,
    min,
    max,
  } = props;

  return (
    <Container>
      <InputLabelHolder labelName={labelName} isRequired={isRequired} />
      <div className="input_block">
        <InputForm
          inputType={inputType}
          inputValue={inputValue}
          placeholder={placeholder}
          onChange={onChange}
          onBlur={onBlur}
          isError={isError}
          isDisabeld={isDisabeld}
          min={min}
          max={max}
        />
      </div>
    </Container>
  );
};

SingleInputFormBlock.defaultProps = {
  isRequired: false as boolean,
};

const Container = styled.div`
  box-sizing: border-box;
`;
export default SingleInputFormBlock;
